<template>
  <tr class="project-table-row">
    <td>
      <ProjectAvatar
        :project="project"
        small
      />
    </td>

    <td>
      <router-link :to="projectDetailsRoute(project)">
        <h5 class="black--text text-body-2 font-weight-medium min-w-150 max-w-300 underlined-hover">
          {{ shortenTitle(project) }}
        </h5>
      </router-link>
    </td>

    <td>
      ID: {{ project.id }}
    </td>

    <td>
      <div class="min-w-90">
        {{ dateRange(project) }}
      </div>
    </td>

    <td>
      {{ project.projectType }}
    </td>

    <td v-if="!campaignView">
      <AppLimitedItems :items="project.campaigns" />
    </td>

    <td>
      <AppAvatarsGroup :team="project.members" />
    </td>

    <td>
      <AppAvatarsGroup :team="project.orderers" />
    </td>

    <td>
      <div class="d-flex align-center">
        <AppStatus
          v-if="project.status"
          :class="{'max-w-300': $vuetify.breakpoint.lgAndDown}"
          :status-text="project.status"
          multiline
        />
      </div>
    </td>

    <td v-if="isBaseTable">
      <ProjectActionsBell :project="project" />
    </td>

    <td v-if="isBaseTable">
      <div class="mt-3">
        <ProjectCardMenu
          :project="project"
          :deletable="deletePermitted"
          @delete="$emit('conditionalDelete')"
        />
      </div>
    </td>
    <td v-if="trashView">
      <div class="d-flex">
        <v-btn
          icon
          color="error"
          @click="$emit('delete')"
        >
          <v-icon>mdi-delete</v-icon>
        </v-btn>
        <v-btn
          icon
          color="primary"
          @click="$emit('bringBack')"
        >
          <v-icon>mdi-restart</v-icon>
        </v-btn>
      </div>
    </td>
  </tr>
</template>

<script>
import { mapGetters } from 'vuex';
import AppStatus from '@/components/UI/AppStatus.vue';
import AppAvatarsGroup from '@/components/UI/AppAvatarsGroup.vue';
import AppLimitedItems from '@/components/UI/AppLimitedItems.vue';
import ProjectCardMenu from '@/components/Projects/ProjectCardMenu.vue';
import ProjectActionsBell from '@/components/Projects/ProjectActionsBell.vue';
import ProjectAvatar from '@/components/Projects/ProjectAvatar.vue';
import projectFormattedInfo from '@/mixins/projectFormattedInfo.vue';

export default {
  props: {
    project: {
      type: Object,
      required: true,
    },
    campaignView: {
      type: Boolean,
      default: false,
    },
    trashView: {
      type: Boolean,
      default: false,
    },
    archive: {
      type: Boolean,
      default: false,
    },
  },

  components: {
    ProjectActionsBell,
    ProjectCardMenu,
    AppAvatarsGroup,
    AppLimitedItems,
    ProjectAvatar,
    AppStatus,
  },

  mixins: [
    projectFormattedInfo, // dateRange, projectDetailsRoute, shortenTitle
  ],

  computed: {
    ...mapGetters('auth', ['checkUserPermissions']),

    isBaseTable() {
      return !this.trashView && !this.campaignView;
    },

    deletePermitted() {
      const availability = ['admin_director', 'chief'];
      return this.checkUserPermissions(availability);
    },
  },
};
</script>

<style lang="scss" scoped>
.project-table-row {
  @media screen and (max-width: 1920px) {
    td {
      font-size: 12px !important;
    }
  }
}
.min-w-90 {
  min-width: 90px;
}
.min-w-150 {
  min-width: 150px;
}
.max-w-300 {
  max-width: 300px;
}
</style>
